"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const ee_ts_1 = require("ee-ts");
const either = __importStar(require("fp-ts/lib/Either"));
const isomorphic_ws_1 = __importDefault(require("isomorphic-ws"));
const TransmissionTypes_1 = require("../common/TransmissionTypes");
const util_1 = require("../common/util");
const ClientChannel_1 = require("./ClientChannel");
const MessengerClientTypes_1 = require("./MessengerClientTypes");
class MessengerClient extends ee_ts_1.EventEmitter {
    constructor(options) {
        super();
        //
        this.state = MessengerClientTypes_1.MessengerClientState.CLOSED;
        this.channels = {};
        // TODO - Audit this behavior over edge cases
        this.start = () => __awaiter(this, void 0, void 0, function* () {
            if (this.socket !== undefined) {
                console.error("Double-start of messenger client - skipping...");
                return;
            }
            return new Promise((resolve, reject) => {
                this.one("ready", () => {
                    this.keepaliveInterval = setInterval(() => {
                        this.sendTransmission(TransmissionTypes_1.buildSystemTransmission(TransmissionTypes_1.buildKeepAlivePingMessage()));
                    }, 90 * 1000);
                    resolve();
                });
                this.one("authFailure", (info) => reject(`Failed to authenticate with server: ${info}`));
                this.one("disconnect", () => {
                    clearInterval(this.keepaliveInterval);
                    reject("Disconnected");
                });
                this.socket = this.run();
            });
        });
        this.shutdown = () => __awaiter(this, void 0, void 0, function* () {
            this.socket.close();
        });
        this.openChannel = (namespace, channelID) => {
            var _a;
            const existing = (_a = this.channels[namespace]) === null || _a === void 0 ? void 0 : _a[channelID];
            if (existing)
                return existing.publicHandle();
            //
            const newChannel = new ClientChannel_1.InternalClientChannel(namespace, channelID, this);
            this.channels[namespace] = Object.assign(Object.assign({}, this.channels[namespace]), { [channelID]: newChannel });
            return newChannel.publicHandle();
        };
        // ************************************************************************************
        this.sendMessage = (message) => {
            this.requireState(MessengerClientTypes_1.MessengerClientState.OPEN_READY);
            const transmission = TransmissionTypes_1.buildApplicationTransmission([message]);
            this.sendTransmission(transmission);
        };
        this.handleSystemMessage = (message) => {
            var _a;
            switch (message.type) {
                case TransmissionTypes_1.SystemMessageType.AuthChallenge:
                    const response = this.options.authenticate(message.challengeData);
                    this.sendTransmission(TransmissionTypes_1.buildSystemTransmission(TransmissionTypes_1.buildAuthResponseMessage(response)));
                    break;
                case TransmissionTypes_1.SystemMessageType.AuthStatus:
                    if (message.success) {
                        this.state = MessengerClientTypes_1.MessengerClientState.OPEN_READY;
                        this.emit("ready");
                    }
                    else {
                        this.state = MessengerClientTypes_1.MessengerClientState.CLOSED;
                        this.emit("authFailure", message.message);
                    }
                    break;
                case TransmissionTypes_1.SystemMessageType.DropChain:
                    const channel = (_a = this.channels[message.namespace]) === null || _a === void 0 ? void 0 : _a[message.channelID];
                    if (channel === undefined) {
                        console.warn("Got a DropChainMessage for a nonexistent channel. Ignoring.");
                        break;
                    }
                    channel.dropChain(message.chainID, message.chainKey);
                    break;
                case TransmissionTypes_1.SystemMessageType.TerminateConnection:
                    this.state = MessengerClientTypes_1.MessengerClientState.CLOSED;
                    this.emit("disconnect", message.userTerminateMessage);
                    break;
                default:
                    throw Error("Received server message in the client, this is invalid.");
            }
        };
        this.handleApplicationMessage = (message) => {
            var _a;
            const channel = (_a = this.channels[message.namespace]) === null || _a === void 0 ? void 0 : _a[message.channelID];
            if (channel === undefined) {
                console.warn("Transmission received for unregistered channel:", message);
                console.warn("Transmission will be dropped.");
                return;
            }
            channel.deliverMessageToApplication(message);
        };
        // ************************************************************************************
        this.requireState = (...states) => {
            // TODO - Use this maybe?
            if (!states.includes(this.state)) {
                throw `Cannot perform operation. State '${this.state}' is not a valid state for this action. Required: ${states}`;
            }
        };
        // ************************************************************************************
        this.run = () => {
            const protocol = this.options.secure ? "wss" : "ws";
            const ws = new isomorphic_ws_1.default(`${protocol}://${this.options.host}:${this.options.port}`);
            ws.onopen = this.handleOpen;
            ws.onmessage = this.handleTransmission;
            ws.onclose = this.handleClose;
            ws.onerror = this.handleError;
            return ws;
        };
        this.handleOpen = () => {
            if (this.state !== MessengerClientTypes_1.MessengerClientState.CLOSED) {
                throw Error("State machine is invalid - received an open event for a socket that should already be open. State: " + this.state);
            }
            this.state = MessengerClientTypes_1.MessengerClientState.OPEN_UNAUTHENTICATED;
        };
        this.handleClose = () => {
            // TODO - Add better-defined behavior for this.
            if (this.state !== MessengerClientTypes_1.MessengerClientState.CLOSED)
                this.emit("disconnect", "Unknown disconnection reason.");
            this.state = MessengerClientTypes_1.MessengerClientState.CLOSED;
        };
        this.handleError = (err) => {
            // TODO - Add better-defined behavior for this.
            console.error("Error - messenger channel invalidated.", err.message ? err.message : err);
            this.state = MessengerClientTypes_1.MessengerClientState.CLOSED;
            this.emit("disconnect", "Socket error");
        };
        this.handleTransmission = (event) => {
            const transmission = util_1.decodeFromJson(event.data, TransmissionTypes_1.TransmissionCodec);
            if (transmission === undefined)
                return; // Failed to decode
            switch (transmission.type) {
                case TransmissionTypes_1.TransmissionType.System:
                    const decoded = TransmissionTypes_1.SystemMessageCodec.decode(transmission.payload);
                    if (either.isLeft(decoded)) {
                        console.warn("Unable to decode system message payload. Ignoring:", transmission.payload);
                        return;
                    }
                    this.handleSystemMessage(decoded.right);
                    break;
                case TransmissionTypes_1.TransmissionType.Application:
                    transmission.payload.forEach((message) => this.handleApplicationMessage(message));
                    break;
            }
        };
        this.notifyChainDrop = (namespace, channelID, chainID, chainKey) => {
            this.sendTransmission(TransmissionTypes_1.buildSystemTransmission(TransmissionTypes_1.buildDropChainMessage(namespace, channelID, chainID, chainKey)));
        };
        this.options = options;
    }
    // ************************************************************************************
    sendTransmission(transmission) {
        this.socket.send(JSON.stringify(transmission)); // FIXME - Something better than this type assertion.
    }
}
exports.default = MessengerClient;
//# sourceMappingURL=MessengerClient.js.map